import styled from "styled-components";
import { TextWidget } from "../../../components/widget/text-widget";

export const KycStatusWidget = styled(TextWidget)`
  svg {
    height: 5em;
    width: 5em;
  }
`;

export const StyledTextWidget = styled(TextWidget)`
  min-width: 0;
`;
